import {
  getAutomatedBreaksSettings,
  mapAPIAutomatedBreaksSettingsToUI
} from '@sdk/automatedBreaks/mappers';

import { useAppSelector } from '@kiosk/common/hooks/redux';

export const useAutomatedBreakSettings = () => {
  const { orgSettings } = useAppSelector(state => state.timeClock.data);

  const automatedBreaks = getAutomatedBreaksSettings(orgSettings);
  const automatedBreaksUI = mapAPIAutomatedBreaksSettingsToUI(automatedBreaks);

  return automatedBreaksUI;
};
